export default [
  {
    path: '/languages',
    name: 'languages',
    component: () => import('./views/LanguagesList'),
    meta: {
      auth: true
    }
  },
  {
    path: '/languages/new',
    name: 'languages.new',
    component: () => import('./views/LanguagesNew'),
    meta: {
      auth: true
    }
  },
  {
    path: '/languages/:id',
    name: 'languages.edit',
    component: () => import('./views/LanguagesEdit'),
    meta: {
      auth: true
    }
  }
]
